import { Switch } from "antd";
import { useTranslation } from "react-i18next";
import { AiOutlineMoon, AiOutlineSun } from "react-icons/ai";

import { useThemeMode } from "sandbox/contexts/ThemeModeContext";

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { t } = useTranslation("sandbox");
  const { mode, toggleMode } = useThemeMode();
  const checked = mode === "dark";

  return (
    <Switch
      className={className}
      checked={checked}
      onChange={toggleMode}
      checkedChildren={<AiOutlineMoon />}
      unCheckedChildren={<AiOutlineSun />}
      aria-label={
        checked
          ? t("components.sandboxHeader.switchToLightMode")
          : t("components.sandboxHeader.switchToDarkMode")
      }
      data-testid="sandbox-theme-toggle"
    />
  );
};
